import {
  deserify,
  IconWrapper,
  ImageWrapper,
  InputFieldContainer,
  IStyles,
  PrimaryButton,
  pxToRem,
  pxTovW,
} from '@geneo2-web/shared-ui';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import {
  Box,
  Button,
  Divider,
  Modal,
  Slide,
  SxProps,
  TextField,
  Typography,
} from '@mui/material';
import { useDownloadContext } from '../../../../../app/Context/DownloadContextProviderV2';
import { interactionEvent } from '../../../../Auth/auth.events';
import { ReactNode, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppSelector } from 'apps/teacher/src/reduxStore/reduxHooks';

const styles: IStyles = {
  root: {},
  iconBox: {
    height: { xs: pxToRem(113), md: pxTovW(143) },
    display: 'flex',
    width: { xs: pxToRem(113), md: pxTovW(143) },
    borderRadius: '50%',
    backgroundColor: 'rgba(255, 255, 255, 1)',
    boxSizing: 'border-box',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    transform: 'translateY(-50%)',
  },
  actionPopupText: {
    margin: {
      xs: '30% auto 20px auto',
      md: `auto auto ${pxTovW(20)} auto`,
    },
    textAlign: 'center',
    //   alignSelf: 'flex-end',
    height: 'max-content',
    width: { xs: '90%', md: pxTovW(388) },
  },
  actionPopupTextSmall: {
    margin: {
      xs: `${pxToRem(60)} auto 0 auto`,
      md: `${pxTovW(92)} auto 0 auto`,
    },
    textAlign: 'center',
    //   alignSelf: 'flex-end',
    height: '100%',
    width: { xs: '90%', md: pxTovW(388) },
  },
};

interface IProps {
  open: boolean;
  handleClose: () => void;
  value: string | undefined;
  onChange?: (e: string | undefined) => void;
  addQuestionsHandler: (prompt: string) => void;
  validationEnabled: boolean;
  validated?: 'success' | 'error';
  onValidateClick: () => void;
  disabled?: boolean;
}
export const AddPromptPopup = (props: IProps) => {
  const {
    open,
    handleClose,
    value,
    onChange,
    addQuestionsHandler,
    validationEnabled,
    validated,
    onValidateClick,
    disabled,
  } = props;

  return (
    <Modal
      open={open}
      onClose={() => {
        onChange && onChange(undefined);
        handleClose();
      }}
    >
      <Slide direction="up" in={open} mountOnEnter unmountOnExit timeout={500}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            width: '100vw',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              // mt: { xs: '18%', md: '10%' },
              gap: { xs: pxToRem(30), md: pxTovW(20) },
              flexDirection: { xs: 'column', md: 'row' },
              alignItems: { xs: 'center', md: 'flex-start' },
              width: { xs: '95%', md: 'unset' },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                boxSizing: 'border-box',
                flexDirection: 'column',
                alignItems: 'center',
                backgroundColor: 'white',
                width: { xs: '100%', md: pxTovW(916) },
                borderRadius: { xs: pxToRem(20), md: pxTovW(20) },
                gap: { xs: pxToRem(10), md: pxTovW(10) },
                paddingX: { xs: pxToRem(20), md: pxTovW(20) },
                paddingY: { xs: pxToRem(15), md: pxTovW(20) },
              }}
            >
              <Box sx={{ width: '100%' }}>
                <Box
                  sx={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <Typography variant="h3" fontWeight={'bold'}>
                    Add AI Questions
                  </Typography>
                  {validationEnabled &&
                    (!validated ? (
                      <PrimaryButton
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          width: 'max-content',
                          borderRadius: '10px',
                          fontSize: '16px',
                          padding: '7px 11px',
                          height: 'unset',
                          boxShadow: 'none',
                        }}
                        onClick={() => {
                          onValidateClick ? onValidateClick() : null;
                        }}
                        disabled={!value}
                      >
                        <Typography
                          variant="cardText"
                          color={'#fff'}
                          sx={{ lineHeight: 1 }}
                        >
                          VALIDATE
                        </Typography>
                      </PrimaryButton>
                    ) : (
                      <Box
                        sx={{
                          backgroundColor:
                            validated == 'success' ? '#D4FFE7' : '#FFE9E9',
                          border:
                            validated == 'success'
                              ? '1px solid #0AA34F57'
                              : '1px solid #F54040',
                          p: '3px 7px',
                          borderRadius: '35px',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '5px',
                        }}
                      >
                        {validated == 'success' ? (
                          <CheckCircleIcon
                            fontSize="small"
                            sx={{ color: '#0F8F10' }}
                          />
                        ) : (
                          <CancelIcon
                            fontSize="small"
                            sx={{ color: '#F54040' }}
                          />
                        )}
                        <Typography
                          variant="cardText"
                          color={'#000'}
                          sx={{ lineHeight: 1 }}
                        >
                          {validated == 'success'
                            ? 'Prompt Validated'
                            : 'Invalid Prompt'}
                        </Typography>
                      </Box>
                    ))}
                </Box>
                <Divider
                  sx={{
                    bgcolor: '#E0E0E0',
                    height: '1px',
                    width: '100%',
                    my: { xs: pxToRem(5), md: pxTovW(5) },
                  }}
                />
              </Box>
              <Box
                sx={{
                  width: '100%',
                  height: { xs: pxToRem(194), md: pxTovW(194) },
                  boxSizing: 'border-box',
                  backgroundColor: '#F5FAFF',
                  borderRadius: pxTovW(15),
                  border: '1px solid #A8D3FC',
                  padding: { xs: pxToRem(10), md: pxTovW(20) },
                  gap: { xs: pxToRem(10), md: pxTovW(10) },
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <Typography variant="h3" fontWeight={'bold'}>
                  Type Prompt
                </Typography>
                <TextField
                  sx={{
                    boxSizing: 'border-box',
                    width: '100%',
                    // height: '100%',
                    height: '80%',

                    borderRadius: pxToRem(9),
                    // paddingY: pxToRem(10),
                    backgroundColor: 'white',
                    overflowY: 'auto',
                    '&>div': {
                      '&::-webkit-scrollbar': { display: 'none' },
                    },
                    '& > div > textarea': {
                      '&::-webkit-scrollbar': { display: 'none' },
                      height: { xs: pxToRem(100), md: pxTovW(83) },
                    },
                  }}
                  placeholder={'Type Your Prompt Here...'}
                  multiline
                  rows={4}
                  variant="outlined"
                  value={value}
                  onChange={(e) => {
                    onChange && onChange(e.target.value);
                  }}
                />
              </Box>
              <PrimaryButton
                variant="contained"
                fullWidth
                sx={{
                  width: { xs: '90%', md: pxTovW(200) },
                  m: 'auto',
                  marginTop: { xs: pxToRem(10), md: pxTovW(20) },
                }}
                disabled={disabled}
                onClick={() => value && addQuestionsHandler(value)}
              >
                <Typography
                  variant="h4"
                  sx={{
                    fontFamily: 'Poppins',
                    fontStyle: 'normal',
                    fontWeight: 'bold',
                    color: '#FFFFFF',
                  }}
                >
                  ADD QUESTIONS
                </Typography>
              </PrimaryButton>
            </Box>

            <Button
              onClick={() => {
                onChange && onChange(undefined);
                handleClose();
              }}
              sx={{ p: '0px' }}
            >
              <IconWrapper
                name="close-yellow"
                size="md"
                parentFolder="icons"
                type="png"
                customSx={{
                  width: { xs: pxToRem(33), md: pxTovW(54) },
                  height: { xs: pxToRem(33), md: pxTovW(54) },
                }}
              />
            </Button>
          </Box>
        </Box>
      </Slide>
    </Modal>
  );
};
